import { Box, Button, Dialog, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { tokens } from '../../../global/theme/tokens';
import FormHelperText from '../FormHelperText';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ExoExplorer from '../../exo/ExoExplorer';
import MediaPreview from '../../exo/explorer/MediaPreview';
import ExoDialog from '../../exo/ExoDialog';
import LabeledBox from '../../special/LabeledBox';
import ClearIcon from '@mui/icons-material/Clear';
const TypeImages = ({
  updateValidationOnChange,
  dataCollection,
  field,
  size,
  errors,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [open, setOpen] = useState(false);

  function handleClickImage() {
    setOpen(!open);
  }

  const handleSelect = (images) => {
    updateValidationOnChange(field.key, images);
    handleClickImage();
  };

  const handleReset = () => {
    updateValidationOnChange(field.key, null);
  };

  return (
    <Box className={`w-full flex gap-2 ${field.disabled ? 'opacity-70' : ''}`}>
      <LabeledBox
        size={size}
        label={`${field.label} ${field.maxItems && `(${field.maxItems} MAX)`}`}
        onClick={() => setOpen(true)}
        sx={dataCollection[field.key] && { padding: '5px 5px' }}
        className="w-full flex flex-wrap gap-1"
      >
        {dataCollection[field.key] && (
          <>
            {dataCollection[field.key].map((image) => (
              <MediaPreview
                src={image.temporaryUrl}
                onlyIcons={false}
                size={size === 'small' ? '28px' : '41px'}
              />
            ))}
          </>
        )}
      </LabeledBox>
      {dataCollection[field.key] && (
        <Button
          onClick={handleReset}
          sx={{
            minWidth: 'unset',
            bgcolor: colors.bgInput,
            aspectRatio: '1/1',
            width: size === 'small' ? '40px' : '53px',
            height: size === 'small' ? '40px' : '53px',
            borderRadius: '10px',
            border: `1px solid transparent`,
            ':hover': {
              bgcolor: colors.error + '30',
              border: `1px solid ${colors.error}80`,
              color: colors.error,
            },
          }}
        >
          <ClearIcon />
        </Button>
      )}
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <ExoExplorer
          onSelect={handleSelect}
          multiSelect
          preSelected={dataCollection[field.key]}
          maxItems={field.maxItems}
          maxSizeKB={field.maxSizeKB}
        />
      </ExoDialog>
    </Box>
  );
};

export default TypeImages;
